import { html } from 'lit';
import { Subscription } from '@common/types/model.d.js';
import { formatMsisdn } from '@common/utils/MobilePhoneNumber.js';
import type { TefComs4p } from '@src/components/TefComs4p.js';

//
// renders a single subscription block in EDIT mode
//
// {subscription msisdn}
//   {app consent BLOCK}
//
export const singleSubscriptionIdentifierBoundEdit = function render(this: TefComs4p, subscription : Subscription) {
  return html`
    <one-section size="xxs" background="muted-2">
      <one-heading level="h6" variant="default">${formatMsisdn(subscription.msisdn)}</one-heading>
    </one-section>

    <one-stack gap="xs">
      ${subscription.apps.map((app) => this.getTemplateFn('singleAppConsentEdit')(app))}
      <one-checkbox ?checked="${!subscription.apps.some((app) => app.granted)}" @change=${() => { this.revokeAllAppConsentsForSubscription(subscription); }}>
        <one-text size="lg">Alle deaktivieren</one-text>
      </one-checkbox>
    </one-stack>
  `;
};
